import store from '../store';
import { fetchEventSource } from '@microsoft/fetch-event-source';

const SSEAPITYPE = {
    'default': '/api/chat/stream?sessionId=',
    'plan': '/api/chat/plan/stream?sessionId=',
    'knowledge': '/api/chat/knowledge/stream?sessionId='
};
/**
 * sse流式API
 */
export default {
    /**
     * sse_post接口发送对话
     */
    sseStream (apiType, sessionId, payload, cb, onError) {
        const sseController = new AbortController();
        const sseSignal = sseController.signal;
        let token = store.state.account.token;
        let API = SSEAPITYPE[apiType] + sessionId;
        // transGpt是demo测试版本，不走公服接口
        let apiPre = '/call-platform';
        if (location.hash.indexOf('transGpt') !== -1) {
            apiPre = '/only-mem-server';
        }
        API = apiPre + API;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        fetchEventSource(API, {
            method: 'POST',
            signal: sseSignal,
            headers: headers,
            body: JSON.stringify(payload),
            onmessage (event) {
                cb && cb(JSON.parse(event.data), sseController);
            },
            onerror (err) {
                // 如果程序代码的逻辑报错也会走入sse的onerror事件
                // 网络异常响应事件
                // 404接口会由浏览器自动抛出异常提示
                sseController.abort(); // 关闭上次请求
                onError && onError(err);
                throw err;
            }
        });
    }
};
